var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 17.5C16.6605 17.5 17.5 16.6605 17.5 15.625C17.5 14.5895 16.6605 13.75 15.625 13.75C14.5895 13.75 13.75 14.5895 13.75 15.625C13.75 16.6605 14.5895 17.5 15.625 17.5Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 4.375H13.125C13.788 4.375 14.4239 4.63839 14.8928 5.10723C15.3616 5.57607 15.625 6.21196 15.625 6.875C15.625 7.53804 15.3616 8.17393 14.8928 8.64277C14.4239 9.11161 13.788 9.375 13.125 9.375H5.625C4.7962 9.375 4.00134 9.70424 3.41529 10.2903C2.82924 10.8763 2.5 11.6712 2.5 12.5C2.5 13.3288 2.82924 14.1237 3.41529 14.7097C4.00134 15.2958 4.7962 15.625 5.625 15.625H13.75",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.f0ec9857d0887ae7eabd63b74a11d5b8.svg";
export { ForwardRef as ReactComponent };